
import { useTranslation } from 'react-i18next';
import { PlanLayout } from "@/components/plans/PlanLayout";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

const PosucoroPage = () => {
  const { t } = useTranslation();

  const benefits = [
    { title: t('plans_detail.posucoro.benefit_0_title'), desc: t('plans_detail.posucoro.benefit_0_desc') },
    { title: t('plans_detail.posucoro.benefit_1_title'), desc: t('plans_detail.posucoro.benefit_1_desc') },
    { title: t('plans_detail.posucoro.benefit_2_title'), desc: t('plans_detail.posucoro.benefit_2_desc') },
  ];

  const requiredDocs = [
    t('plans_detail.posucoro.req_doc_0'),
    t('plans_detail.posucoro.req_doc_1'),
    t('plans_detail.posucoro.req_doc_2'),
    t('plans_detail.posucoro.req_doc_3'),
  ];

  return (
    <PlanLayout
      title={t('plans_detail.posucoro.title')}
      subtitle={t('plans_detail.posucoro.subtitle')}
      imageUrl="https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7"
    >
      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 mt-8 text-white">{t('plans_detail.common.overview')}</h2>
        <p className="mb-4 text-white/70 leading-relaxed">
          {t('plans_detail.posucoro.overview_p1')}
        </p>
        <p className="mb-8 text-white/70 leading-relaxed">
          {t('plans_detail.posucoro.overview_p2')}
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 text-white">{t('plans_detail.posucoro.benefits_title')}</h2>
        <motion.div
          className="space-y-4 mb-8"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.08 } } }}
        >
          {benefits.map(({ title, desc }) => (
            <motion.div
              key={title}
              variants={{ hidden: { opacity: 0, y: 16 }, visible: { opacity: 1, y: 0, transition: { duration: 0.4 } } }}
              whileHover={{ scale: 1.02 }}
              className="border border-white/10 bg-white/5 p-6 rounded-xl flex items-start gap-4"
            >
              <CheckCircle className="text-[#c9a84c] mt-1 h-6 w-6 flex-shrink-0" />
              <div>
                <h3 className="font-bold text-lg mb-2 text-white">{title}</h3>
                <p className="text-white/65 leading-relaxed">{desc}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 text-white">{t('plans_detail.posucoro.required_docs_title')}</h2>
        <ul className="list-disc pl-6 mb-8 space-y-2 text-white/70">
          {requiredDocs.map((doc, i) => (
            <li key={i}>{doc}</li>
          ))}
        </ul>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <div className="border border-[#c9a84c]/30 bg-[#c9a84c]/10 p-6 rounded-xl mb-8">
          <h3 className="font-bold text-lg mb-3 text-[#c9a84c]">{t('plans_detail.common.useful_links')}</h3>
          <ul className="space-y-2">
            <li>
              <a
                href="https://www.chusho.meti.go.jp/keiei/kakushin/kaizen/index.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#c9a84c] hover:underline text-sm"
              >
                {t('plans_detail.posucoro.link_0_text')}
              </a>
            </li>
            <li>
              <a
                href="https://www.mirasapo-plus.go.jp/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#c9a84c] hover:underline text-sm"
              >
                {t('plans_detail.posucoro.link_1_text')}
              </a>
            </li>
          </ul>
        </div>

        <div className="border border-white/10 bg-white/5 p-6 rounded-xl">
          <h3 className="font-bold text-lg mb-3 text-white">{t('plans_detail.common.contact_title')}</h3>
          <p className="mb-4 text-white/65 leading-relaxed">
            {t('plans_detail.posucoro.contact_desc')}
          </p>
          <Button
            onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSfGctjmssSGu73JcGfPeECrLstNGZF5w_36ePFOZLw7s-1HPg/viewform', '_blank', 'noopener,noreferrer')}
            variant="outline"
            size="lg"
            className="border-[#c9a84c] text-[#c9a84c] hover:bg-[#c9a84c]/10 bg-transparent"
          >
            {t('plans_detail.posucoro.contact_button')}
          </Button>
        </div>
      </motion.section>
    </PlanLayout>
  );
};

export default PosucoroPage;
